import type { ChainId } from "@/query/graphql"
import type { UseCorrectChainErrors } from "@/web3/helpers/chain"
import { getCorrectChain } from "@/web3/helpers/chain"

type Values = {
  error?: UseCorrectChainErrors
  isCorrectChain: boolean
}

type Props = {
  chainId: ChainId | undefined
  chainReference: number | undefined
}

export const useCorrectChain = ({ chainId, chainReference }: Props): Values => {
  return getCorrectChain({ chainId, chainReference })
}
